import Privacy from "../Privacy"

const CommunityGuidelines = () => {
    return (
        <Privacy>
            <div className="w-full text-[#475467] ">
                <h1 className="text-[28px] text-black pt-4 font-bold ">
                    Community Guidelines
                </h1>
                <p className=" pt-4" id="OUR SERVICES">
                    <span className="font-semibold "> Effective Date:</span> June 5th, 2025
                </p>

                <div className="my-6">
                    <p>
                        <span className="font-bold">Arad</span> (“we,” “us,” or “our”) is committed to fostering a secure, respectful, and responsible community environment for all users (“you,” “your”). These Community Guidelines (“Guidelines”) set forth the standards of conduct and content expected on the Arad platform (the “App”). By accessing or using the App, you agree to comply with these Guidelines in their entirety.

                    </p>
                </div>

                <div className="my-6">

                    <h1 className=" text-[28px] py-4" id="OUR SERVICES">
                        1. Zero Tolerance Policy on Child Sexual Abuse and Exploitation (CSAE)
                    </h1>
                    <p>
                        Arad maintains a strict zero-tolerance stance toward any content, behavior, or conduct that involves child sexual abuse or exploitation. Posting, sharing, distributing, soliciting, or facilitating any CSAE material or conduct is strictly prohibited. Any violation of this provision will result in immediate removal of the offending content, suspension or termination of user accounts, and prompt notification to the appropriate law enforcement and child protection authorities.
                    </p>
                </div>

                <div className="my-6">
                    <h1 className=" text-[28px] py-4" id="OUR SERVICES">
                        2. Respectful and Lawful Conduct
                    </h1>
                    <p>
                        Users shall conduct themselves in a manner that respects the rights and dignity of others. Harassment, threats, bullying, hate speech, discrimination, or any conduct that infringes upon the rights of other users is expressly forbidden. Users must refrain from posting inflammatory, defamatory, or otherwise unlawful content.
                    </p>
                </div>

                <div className="my-6">
                    <h1 className=" text-[28px] py-4" id="OUR SERVICES">
                        3. Accuracy and Integrity of Information
                    </h1>
                    <p>Users are obligated to post truthful, accurate, and verifiable information relevant to incidents, events, or updates concerning public safety or community interest. The dissemination of false, misleading, defamatory, or unsubstantiated claims is prohibited. Users must take all reasonable measures to safeguard the privacy and confidentiality of individuals involved in reported incidents, particularly minors and victims.
                    </p>
                </div>

                <div className="my-6">
                    <h1 className=" text-[28px] py-4" id="OUR SERVICES">
                        4. Permissible Content and Relevance
                    </h1>
                    <p>
                        Content posted on the App must be germane to the purpose of the platform — sharing timely and relevant information regarding incidents, events, and alerts. Content deemed off-topic, unsolicited advertisements, spam, or solicitations will be subject to removal. Graphic or sensitive content should only be posted when necessary to inform or warn users and must be accompanied by appropriate content warnings.
                    </p>
                </div>

                <div className="my-6">
                    <h1 className=" text-[28px] py-4" id="OUR SERVICES">
                        5. Privacy and Data Protection
                    </h1>
                    <p>
                        Users shall respect the privacy and confidentiality rights of all individuals. The sharing or disclosure of personally identifiable information (“PII”) without appropriate consent is strictly prohibited. Users must comply with all applicable data protection and privacy laws, including but not limited to those concerning minors and vulnerable persons.
                    </p>
                </div>

                <div className="my-6">
                    <h1 className=" text-[28px] py-4" id="OUR SERVICES">
                        6. Intellectual Property Compliance
                    </h1>
                    <p className="mb-4">
                        Users warrant that all content submitted to the platform does not infringe any third-party intellectual property rights, including copyrights and trademarks. Unauthorized use of protected materials is prohibited and may result in removal and legal action.
                    </p>
                </div>

                <div className="my-6">
                    <h1 className=" text-[28px] py-4" id="OUR SERVICES">
                        7. Moderation and Enforcement
                    </h1>
                    <p className="mb-4">
                        Arad reserves the right to moderate all content posted on the platform. This includes, without limitation, reviewing, editing, or removing content that violates these Guidelines or applicable law. Users are required to cooperate with moderation processes and accept moderation decisions, including content removal, account suspensions, or terminations. Appeals may be submitted through designated channels, but moderation actions remain effective pending review.
                    </p>
                </div>

                <div className="my-6">
                    <h1 className=" text-[28px] py-4" id="OUR SERVICES">
                        8. Prohibition on Circumvention
                    </h1>
                    <p className="mb-4">
                        Users must comply with all applicable local, state, national, and international laws and regulations while using the App. Any illegal conduct, including but not limited to trafficking, exploitation, or threats of violence, is strictly prohibited and will be reported to law enforcement authorities.
                    </p>
                </div>

                <div className="my-6">
                    <h1 className=" text-[28px] py-4" id="OUR SERVICES">
                        10. Promotion of Positive Community Engagement
                    </h1>
                    <p className="mb-4">
                        Users are encouraged to contribute constructively to the community, foster respectful dialogue, and support fellow users in a manner consistent with these Guidelines.
                    </p>
                </div>

                <div className="my-6">
                    <h1 className=" text-[28px] py-4" id="OUR SERVICES">
                        Consequences of Non-Compliance
                    </h1>
                    <p>
                        Failure to adhere to these Guidelines may result in one or more of the following actions, at Arad’s sole discretion:
                    </p>
                    <ul className="list-disc ml-10">
                        <li className="py-2">Removal of content</li>
                        <li className="py-2">Temporary suspension or permanent termination of user accounts</li>
                        <li className="py-2">Reporting to law enforcement or regulatory authorities</li>
                        <li className="py-2">Pursuit of legal remedies, including injunctions and damages</li>
                    </ul>
                </div>

                <div className="my-6">
                    <h1 className=" text-[28px] py-4" id="OUR SERVICES">
                        Reporting and Contact Information
                    </h1>
                    <p>
                        Users are encouraged to report any violations of these Guidelines via the in-App reporting mechanism or by contacting Arad at:
                    </p>
                        <p className="pb-1">
                            <span className="font-bold">Email:</span> support@myaradugbo.com
                        </p>
                        <p className="pb-1">
                            <span className="font-bold">Phone:</span> (908) 900-1277
                        </p>
                </div>
                <p>Users are encouraged to report any violations of these Guidelines via the in-App reporting mechanism or by contacting Arad at:
                </p>
            </div>
        </Privacy>
    )
}

export default CommunityGuidelines